import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface TaxCondition {
      id?: string;
      fieldName: string;
      operator: string;
      fieldValue: string;
}

export interface TaxRule {
      id?: string;
      orgId: string | null;
      customerGroupId: string | null;
      itemGroupId: string | null;
      warehouseStateId: string | null;
      customerStateId: string | null;
      countryId: string | null;
      currencyId: string | null;
      fiscalPositionId: string | null;
      taxGroupId: string;
      customerGroupName?: string | null;
      itemGroupName?: string | null;
      warehouseStateName?: string | null;
      customerStateName?: string | null;
      countryName?: string | null;
      currencyName?: string | null;
      fiscalPositionName?: string | null;
      taxGroupName?: string;
      transactionType: string;
      priority: number;
      isActive: boolean;
      conditions: TaxCondition[];
}

export interface TaxGroupLine {
      id?: string;
      taxGroupId?: string;
      taxGroupName?: string;
      taxCode: string;
      taxName: string;
      rate: number;
      calculationMethod: string;
      sequenceNo: number;
      isCompound: boolean;
}

export interface TaxGroup {
      id?: string;
      orgId: string | null;
      code: string;
      name: string;
      taxType: string;
      isActive: boolean;
      countryCode: string | null;
      transactionType: string | null;
      isInclusive: boolean;
      fiscalPositionCode: string | null;
      priorityNo: number;
      lines: TaxGroupLine[];
}

export interface DynamicLookupItem {
      id: string;
      code: string;
      name: string;
}

@Injectable({
      providedIn: 'root'
})
export class TaxService {
      private baseUrl = 'https://localhost:7056/api/tax';

      constructor(private http: HttpClient) { }

      // Tax Rules Endpoints
      getAllRules(): Observable<TaxRule[]> {
            return this.http.get<TaxRule[]>(`${this.baseUrl}/rules`);
      }
      getRuleById(id: string): Observable<TaxRule> {
            return this.http.get<TaxRule>(`${this.baseUrl}/rules/${id}`);
      }
      createRule(rule: TaxRule): Observable<{ id: string }> {
            return this.http.post<{ id: string }>(`${this.baseUrl}/rules`, rule);
      }
      updateRule(id: string, rule: TaxRule): Observable<void> {
            return this.http.put<void>(`${this.baseUrl}/rules/${id}`, rule);
      }
      deleteRule(id: string): Observable<void> {
            return this.http.delete<void>(`${this.baseUrl}/rules/${id}`);
      }

      // Tax Groups Endpoints
      getAllGroups(): Observable<TaxGroup[]> {
            return this.http.get<TaxGroup[]>(`${this.baseUrl}/groups`);
      }
      getGroupById(id: string): Observable<TaxGroup> {
            return this.http.get<TaxGroup>(`${this.baseUrl}/groups/${id}`);
      }
      createGroup(group: TaxGroup): Observable<{ id: string }> {
            return this.http.post<{ id: string }>(`${this.baseUrl}/groups`, group);
      }
      updateGroup(id: string, group: TaxGroup): Observable<void> {
            return this.http.put<void>(`${this.baseUrl}/groups/${id}`, group);
      }
      deleteGroup(id: string): Observable<void> {
            return this.http.delete<void>(`${this.baseUrl}/groups/${id}`);
      }

      // New generic method for SP data
      getDynamicDropdown(type: string): Observable<DynamicLookupItem[]> {
            return this.http.get<DynamicLookupItem[]>(`${this.baseUrl}/tax-dropdowns/${type}`);
      }
}